import { ApolloLink } from '@apollo/client';

export const LoadReason = {
    INITIAL: 'initial',
    REMOUNT: 'remount',
    GROUP_CHANGE: 'groupChange',
    DATASET_CHANGE: 'datasetChange',
    TIME_RANGE_CHANGE: 'timeRangeChange',
    LAYOUT_RESET: 'layoutReset',
    LAYOUT_OPTIONS_CHANGE: 'layoutOptionsChange',
};

// Only for readability in devtools and request URLs; the API takes the name from the request body.
export const buildGraphQlUri = (apiBaseUrl, operation) =>
    operation.operationName
        ? `https://${apiBaseUrl}/graphql?op=${encodeURIComponent(
              operation.operationName
          )}`
        : `https://${apiBaseUrl}/graphql`;

export const buildDiagnosticHeaders = (operation) => {
    const { loadReason, networkRetryCount, alreadyRetried } =
        operation.getContext();

    const headers = {};
    if (loadReason) {
        headers['x-fort-load-reason'] = loadReason;
    }
    if (alreadyRetried) {
        headers['x-fort-retry'] = 'auth';
    } else if (networkRetryCount) {
        headers['x-fort-retry'] = 'network';
    }
    return headers;
};

export const diagnosticHeadersLink = new ApolloLink((operation, forward) => {
    operation.setContext(({ headers = {} }) => ({
        headers: { ...headers, ...buildDiagnosticHeaders(operation) },
    }));
    return forward(operation);
});
